import React, { useState, useEffect } from 'react';
import axios from 'axios';




const Partners = () => {


const [title, setTitle] = useState('');
const [paragraph, setParagraph] = useState('');
const [images, setImages] = useState([]);




useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get('https://back.zubilaw.com/partnerstitle/list');
      if (response.data.success && response.data.data.length > 0) {
        // Access the first item in the array
        setTitle(response.data.data[0].title);
        setParagraph(response.data.data[0].paragraph);
      } else {
        console.log('Data not found');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  fetchData();
}, []);


useEffect(() => {
  const fetchImages = async () => {
    try {
      const response = await axios.get('https://back.zubilaw.com/projectsimages/list');
      if (response.data.success && response.data.data) {
        setImages(response.data.data); // Set the images state with the fetched data
      } else {
        console.log('No images found');
      }
    } catch (error) {
      console.error('Error fetching images:', error);
    }
  };

  fetchImages();
}, []);




  return (
    <div className=" mx-auto px-4 md:px-0 pb-12 mx-auto xl:max-w-7xl pt-32"style={{ backgroundColor: 'white' }}>
    <div className="flex flex-col sm:flex-row items-center sm:items-start justify-center gap-8 sm:gap-10 xl:gap-20 ">

      <div className="flex items-center mb-8 sm:mb-0 ml-5 sm:pt-2 ">
      <h2 className="text-2xl font-semibold text-[#972a36]" style={{ fontFamily: 'Arial' }}>
  {title} <br className="hidden sm:block" /> {paragraph}
</h2>

        <span className="bg-[#777777] w-0.5 h-14 inline-block align-middle ml-3"></span>
      </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-8 w-full md:max-w-[760px] xl:max-w-[860px] my-10 md:my-0 xl:my-0">
        {images.map((image, index) => (
          <div key={index} className="flex items-center justify-center w-24 sm:w-28 md:w-24 xl:w-28">
            <img
              src={`https://back.zubilaw.com/${image.path}`}
              alt={`Award ${index + 1}`}
              className="max-w-full max-h-24 object-contain"
            />
          </div>
  ))}
</div>
      
    </div>
</div>

);
};

export default Partners;
